import dateize from '@sdk/helpers/formatters/dateize';

export default function setter(value) {
  return dateize(value);
}
